// extracted by mini-css-extract-plugin
export default {"card":"Card_card__tWMaN","card__header":"Card_card__header__GnFFd","avatar":"Card_avatar__FEz2e","info":"Card_info__6GFHj","rating":"Card_rating__mMylQ"};